import { useQueryState, useAppStateStore } from '@ywwwtseng/react-kit';
import { type UseFormProps, useForm } from './useForm';
import type { FormValues } from './types';

interface UseGlobalFormProps extends UseFormProps {
  name: string;
}

export function useGlobalForm<T extends FormValues>(props: UseGlobalFormProps) {
  const values = useQueryState<T | undefined>(props.name);
  const { update } = useAppStateStore();
  const form = useForm({
    values: {
      default: values ?? props.values.default,
    },
  });

  const setValues = (values: T) => {
    form.setValues(values);
    update([
      {
        type: 'update',
        target: props.name,
        payload: values,
      },
    ]);
  };

  const reset = () => {
    update([
      {
        type: 'update',
        target: props.name,
        payload: undefined,
      },
    ]);
  };

  return {
    ...form,
    reset,
    setValues,
  };
}
